export default __webpack_public_path__ + "static/media/banner1.b1116bff.jfif";